__turbopack_context__.v({
  "badge": "uT8nJW_badge",
  "shapePill": "uT8nJW_shapePill",
  "shapeRectangle": "uT8nJW_shapeRectangle",
  "size-lg": "uT8nJW_size-lg",
  "size-md": "uT8nJW_size-md",
  "size-sm": "uT8nJW_size-sm",
  "size-xl": "uT8nJW_size-xl",
  "tone-default": "uT8nJW_tone-default",
  "tone-error": "uT8nJW_tone-error",
  "tone-info": "uT8nJW_tone-info",
  "tone-success": "uT8nJW_tone-success",
  "tone-warning": "uT8nJW_tone-warning",
});
